// @TODO: Export this component to be shared. When this is done, it can replace portals PaymentMethodRowIcon component

import { CardBrand } from '@afterpay/types'
import { IconSizes, PaymentIcon, PaymentIconNames, IconNames } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import React, { FunctionComponent } from 'react'
import { PaymentMethodType } from '../../model'

export type IconType = CardBrand | Exclude<PaymentMethodType, PaymentMethodType.CREDIT_CARD>

interface Props {
  type?: IconType
  size?: IconSizes
}

const iconNames: Partial<Record<IconType, PaymentIconNames | IconNames>> = {
  [PaymentMethodType.APPLE_PAY]: 'Applepay',
  [PaymentMethodType.ACH_BANK_ACCOUNT]: 'GenericBank',
  [CardBrand.MASTERCARD]: 'Mastercard',
  [CardBrand.VISA]: 'Visa',
  [CardBrand.AMEX]: 'Amex',
  [CardBrand.DINERS_CLUB]: 'Dinersclub',
  [CardBrand.DISCOVER]: 'Discover',
  [PaymentMethodType.CASH_APP_PAY]: 'CashPay',
}

export const PaymentMethodIcon: FunctionComponent<Props> = ({ type, size = 'Medium' }) => {
  const { t } = useTranslation()

  if (typeof type !== 'undefined') {
    const typeKey = type.toLowerCase().replace(/_/g, '')

    return <PaymentIcon name={iconNames[type]} title={t(`paymentMethod:${typeKey}`)} size={size} />
  } else {
    return null
  }
}
